export const DELETE_ATOM_MODAL = 'DELETE_ATOM_MODAL'
export const DELETE_ATOM_ALERT_MODAL = 'DELETE_ATOM_ALERT_MODAL'
